/* eslint-disable no-unused-vars */

/* eslint-disable react/prop-types */

/* eslint-disable react/display-name */
import { getYear, subYears } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Button from 'components/atomic/Button';
import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: ${theme.spaces.smallX}px;

  margin-bottom: ${theme.spaces.smallX}px;

  :last-child {
    grid-column-start: ${({ count }) => count % 5};
    grid-column-end: 6;
  }

  ${({ loading }) =>
    loading &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
    `}

  @media ${theme.devices.tablet} {
    grid-template-columns: repeat(2, 1fr);

    :last-child {
      grid-column-start: ${({ count }) => count % 2};
      grid-column-end: 3;
    }
  }
`;

const StyledCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${theme.spaces.regular}px;
  border-radius: 8px;
  border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
  background: ${hexToRGBA(theme.colors.indigo.primary, 0.02)};
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${theme.spaces.regular}px;
`;

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
  flex-grow: 1;
`;

const StyledLink = styled.div`
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.4;
      color: red;
    `}

  &:hover {
    text-decoration: underline;
    color: ${theme.colors.gray.secondary};
  }
`;

const DocUploadCards = ({ loading, items = [], onAdd }) => {
  const prevYearTag = getYear(subYears(new Date(), 1));

  const handleAdd = (fileTypeCode) => () => {
    onAdd && onAdd(fileTypeCode);
  };

  if (!items.length) {
    return null;
  }

  return (
    <StyledContainer count={items.length}>
      {items.map(({ code, value, countOfFiles = {} }) => (
        <StyledCardContainer key={code}>
          <StyledIconContainer>
            <Icon
              alias={countOfFiles[prevYearTag] > 0 ? ICON_ALIASES.tickCircleFilled : ICON_ALIASES.tickCircle}
              height={20}
              width={20}
              color={countOfFiles[prevYearTag] > 0 ? theme.colors.indigo.primary : theme.colors.gray.secondary}
            />
          </StyledIconContainer>
          <Text bottomSpace={theme.spaces.regular * 3}>{value}</Text>
          <StyledButtonContainer>
            <Button
              color={theme.colors.indigo.primary}
              disabled={loading || countOfFiles[prevYearTag] > 0}
              onClick={handleAdd(code)}
            >
              Upload
            </Button>

            <StyledLink disabled={!countOfFiles[prevYearTag]} onClick={handleAdd(code)}>
              <Text size={theme.fontSizes.small} color={theme.colors.gray.secondary}>
                + Add Additional
              </Text>
            </StyledLink>
          </StyledButtonContainer>
        </StyledCardContainer>
      ))}
    </StyledContainer>
  );
};

DocUploadCards.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      value: PropTypes.string,
      countOfFiles: PropTypes.object,
    })
  ),
  onAdd: PropTypes.func,
};

export default DocUploadCards;
